import { render, staticRenderFns } from "./testGlya.vue?vue&type=template&id=03c1c849&scoped=true&"
import script from "./testGlya.vue?vue&type=script&lang=js&"
export * from "./testGlya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1c849",
  null
  
)

export default component.exports